// Func = limiting Scope for this file
var lastScrollTop = 0;
var number_inc = false;
var position_counters = 0;

(function(){

	/* Mobile Burguer Menu */ 
	let burgerMenu = document.getElementById('burgerMenu');
	let MobileMenu = document.getElementById('menuMobile');
	 let closeMobileMenu = document.getElementById('closeMobileMenu');
	
	if(burgerMenu){
		burgerMenu.addEventListener("click", function(){ 
			MobileMenu.classList.add('open');
		});
		closeMobileMenu.addEventListener("click", function(e){ 
			e.preventDefault;
			MobileMenu.classList.remove('open');
		});
	}


	Number.prototype.format = function(n) {
		var r = new RegExp('\\d(?=(\\d{3})+' + (n > 0 ? '\\.' : '$') + ')', 'g');
		return this.toFixed(Math.max(0, Math.floor(n))).replace(r, '$&,');
	};

	var number_inc = false;

	$(document).ready(function () {
		if(document.querySelectorAll(".properties-filter .properties-filter__options li").length > 0){
			/* Properties Filter Quad Functionality */
			let propertiesOptions = document.querySelectorAll(".properties-filter .properties-filter__options li");
			for(let c = 0; c < propertiesOptions.length; c++){
				propertiesOptions[c].addEventListener('click', function () {
					let currentOption = this.getAttribute("data-ref");
					document.querySelectorAll(".properties-filter [data-ref]").forEach(item => { item.classList.remove('active'); })
					document.querySelectorAll(` [data-ref="${currentOption}"] `).forEach(item => { item.classList.add('active'); })
				});
			}
			/* Show or Hide Options */
			let selectDropdown = document.getElementById( 'selectFilter' );
			let optionsList = document.querySelector( '.properties-filter ul' );
			let optionsListHeight = optionsList.offsetHeight;
			/* Initialize close */
			optionsList.style.height = "0px";

			/* Open Select */
			selectDropdown.addEventListener('click', function(){
				selectDropdown.classList.toggle("close");
				optionsList.classList.toggle("open");
				if(optionsList.classList.contains("open")){
					optionsList.style.height = optionsListHeight+"px";
				} else{
					optionsList.style.height = "0px";
				}
			});


		}

		/* END */
		/* END */

		// Main Nav Dropdown
		 $("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

	});


	window.onload = function() {

		//scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};



}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;


	if(window.innerWidth > 768){
		if($('.card__number ').length > 0){
			position_counters = $('.card__number ').offset().top - 870;

		
			
			
			
			if( st > position_counters && !number_inc ){
				
				$('.count').each(function () {
					$(this).removeClass('off');
					$('.item').removeClass('off');
					$(this).prop('counter', 0).animate({
						counter: $(this).text()
					}, {
						duration: 2000,
						//easing: 'easeOutExpo',
						step: function (step) {
							$(this).text('' + step.format());
						}
					});
				});
				number_inc = true;
			}
		}
	}






	if(st > 40){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}